export const modalOn = () => {
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
};

export const modalOff = () => {
  document.body.style.overflow = 'scroll';
  document.body.style.position = 'relative';
};
